import React from 'react'
import { Collapse ,Divider} from 'antd';
import {

    BellOutlined  ,
  
  } from '@ant-design/icons';
  
  
import {Table} from 'semantic-ui-react'
const { Panel } = Collapse;
 const ViewMarks = () => {
    const text = `
    A dog is a type of domesticated animal.
    Known for its loyalty and faithfulness,
    it can be found as a welcome guest in many households across the world.
  `
     return(
         <>
           <Divider
            orientation="left" plain style={{ fontSize: '16px', color: '#08c' }}>
            <BellOutlined  style={{ fontSize: '16px', color: '#08c' }} >
                </BellOutlined> &nbsp;&nbsp; View Marks</Divider>
       <Collapse accordion>
    <Panel header="semester -1" key="1">
      
    <Table color="blue" >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Subject</Table.HeaderCell>
            <Table.HeaderCell>Obtained Marks</Table.HeaderCell>
            <Table.HeaderCell>Max Marks</Table.HeaderCell>
            <Table.HeaderCell> Attendence</Table.HeaderCell>
            <Table.HeaderCell> Total</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Table.Row>
            <Table.Cell>Apples</Table.Cell>
            <Table.Cell>200</Table.Cell>
            <Table.Cell>0g</Table.Cell>
            <Table.Cell>04g</Table.Cell>
            <Table.Cell>04g</Table.Cell>
          </Table.Row>
        
        </Table.Body>
      </Table>
    </Panel>
    <Panel header="semester - 2" key="2">
      <p>{text}</p>
    </Panel>
    <Panel header="semester -3" key="3">
      <p>{text}</p>
    </Panel>
  </Collapse>,
   </>

     )
 }

export default ViewMarks

